import env from './env';
import { getNotchHeight } from 'root/common/nativeApi';
export default function(h = 0) {
    const windowWidth = document.documentElement.clientWidth || window.localStorage.getItem('windowWidth') * 1 || 0;
    let menuHeight;
    if (env.isIos) {
        menuHeight = env.isApp ? window.localStorage.getItem('iosMenuHeight') : 0;
    } else {
        menuHeight = getNotchHeight();
    }
    const radio = Number(windowWidth) / 7.5;
    const height = h * radio + Number(menuHeight);
    return height + 'px';
}
